<template>
    <el-card class="mt20">
        <template slot='header'>
        <div>
            权限设置
        </div>
        </template>
        <el-collapse v-model="a1" @change="handleChange">
            <!-- 菜单一级 分组 start -->
            <el-collapse-item v-for="(el, i) in list" :key="i" :name="el.id">
                <!-- 分组启用的开关 start -->
                <template slot='title'>
                    {{el.name}}
                    <el-switch
                        v-model="el.status"
                        active-text=""
                        inactive-text=""
                        class="powerSwitch">
                    </el-switch>
                </template>
                <!-- 分组启用的开关 end -->

                <el-collapse v-model="a2" @change="handleChange"  v-if="el.status">
                    <!-- 二级菜单项 start -->
                    <el-collapse-item v-for="(child, k) in el.children" :key="k" :name="child.id">
                        <!-- 分组启用的开关 start -->
                        <template slot='title'>
                            {{child.name}}
                            <el-switch
                                v-model="child.status"
                                active-text=""
                                inactive-text=""
                                class="powerSwitch">
                            </el-switch>
                        </template>
                        <!-- 分组启用的开关 end -->
                        <template v-if="child.status">
                            <!-- 具体页嘛单独的配置 start -->
                            <table v-for="(page, j) in child.page" :key="j">
                                <tr>
                                    <td class="power-page-title">{{page.name}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <template v-for="btn in page.buttons">
                                            <el-checkbox v-model="btn.status">{{btn.name}}</el-checkbox>  
                                        </template>
                                    </td>
                                </tr>
                            </table>
                            <!-- 具体页嘛单独的配置 end -->
                        </template>
                        <h2 class="tc" v-else>未启用</h2>
                    </el-collapse-item>
                    <!-- 二级菜单项 end -->
                </el-collapse>
                <h2 class="tc" v-else>未启用</h2>
            </el-collapse-item>
            <!-- 菜单一级 分组 start -->
        </el-collapse>
    </el-card>
</template>
<script>
    export default {
        props: {
            list: {
                type: Array
            }
        },
        data () {
            return {
                a1: '',
                a2: ''
            }
        },
        methods: {
            handleChange () {}
        }
    }
</script>